import dayjs from 'dayjs';
import { isNil } from 'lodash';

import { SHORT_MONTH_DAY_YEAR_FORMAT } from 'constants/date';

import { ACTIVITY_FEED_AS_OF_PREFIX } from './activityFeed.constants';

// Composes the since-last-visit ribbon chip text from a milestone event. Loan
// last-4 only — no borrower name (the endpoint never returns one).
const mapEvent = event => ({
  id: `activity-${event.applicationId}-${event.occurredAt}`,
  applicationId: event.applicationId ?? null,
  text: `${event.milestoneLabel} — ·${event.loanNumberLast4}`,
});

const getActivityFeedSinceLabel = since => {
  if (isNil(since)) {
    return null;
  }

  return `${ACTIVITY_FEED_AS_OF_PREFIX} ${dayjs(since).format(SHORT_MONTH_DAY_YEAR_FORMAT)}`;
};

/**
 * Maps the loan-activity endpoint into the since-last-visit ribbon display shape.
 * Returns null when the response is missing so the reducer holds its empty state.
 * @param {object|null} data - { events, since, asOf }
 * @returns {object|null}
 */
export const mapActivityFeed = data => {
  if (isNil(data)) {
    return null;
  }

  return {
    events: (data.events ?? []).map(mapEvent),
    since: data.since ?? null,
    sinceLabel: getActivityFeedSinceLabel(data.since),
  };
};
